import React from 'react';
import { Controller, useFormState } from 'react-hook-form';
import SelectInput from './SelectInput';
import { get as getError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
// import cn from 'classnames';

const SelectInputController = ({
  name,
  control,
  ...rest
}) => {
  const [t] = useTranslation();
  const { errors } = useFormState({ control });
  const error = getError(errors, name);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <SelectInput
          {...field}
          {...rest}
          placeholder={rest.placeholder || 'Выберите'}
          selected={field.value}
          error={t(error?.message)}
        />
      )}
    />
  );
};

export default SelectInputController;
